import { render, staticRenderFns } from "./BotInfo.vue?vue&type=template&id=98424134&scoped=true&lang=pug"
import script from "./BotInfo.vue?vue&type=script&lang=js"
export * from "./BotInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98424134",
  null
  
)

export default component.exports